export default __webpack_public_path__ + "static/media/chaxun.7f9733da.png";